import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';
import { useLanguage } from '../contexts/LanguageContext';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { landingPathForRole } from '../utils/roleLanding';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  padding: 24px;
`;

interface AccessDeniedProps {
  message?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ message }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { user } = useAuth();

  return (
    <Container>
      <Result
        status="403"
        icon={<LockOutlined />}
        title={t('errors.accessDenied')}
        subTitle={message || t('errors.noPermissionToAccess')}
        extra={
          <Button type="primary" onClick={() => navigate(landingPathForRole(user?.role, user?.permissions))}>
            {t('common.backToDashboard')}
          </Button>
        }
      />
    </Container>
  );
};

export default AccessDenied;
